import { getCookie, setCookie } from "@workspace/cookies/browser";

const useOtpValue = () => {
  const otpValue = getCookie("oauth_otp");
  const inThirtySeconds = () => new Date(Date.now() + 30000);
  const setOtpValue = (value: string) =>
    setCookie("oauth_otp", value, { expires: inThirtySeconds() });

  return [otpValue, setOtpValue] as const;
};

export default useOtpValue;
